module.exports = __webpack_public_path__ + "static/media/sign-in-alt.b1013156.svg";